import {default as React} from 'react'
import Gallery from "./gallery";
import MediaItem from "../models/media-item";
import {AlbumInfo} from "../models/responses";
import './album-viewer.css'
import {User} from "../types/user";
import {useDispatch, useSelector} from "react-redux";
import {doFilesUpload} from "../store/file-upload-actions";
import {RootState} from "../reducers/root-reducer";
import {SHOW_LOGIN_MODAL} from "../store/modal-action-types";

interface Props {
    images: MediaItem[]
    users: User[]
    albumInfo: AlbumInfo
}

function AlbumViewer(props: Props) {

    // const shareSubject = "Check this album on givemethatpicture.com";
    // const shareBody = window.location.href;
    const dispatch = useDispatch()
    const user = useSelector<RootState, User | undefined>(state => state.appState.user)
    const isUploadInProgress = useSelector<RootState, boolean>(state => state.uploadFiles.fileProgress !== undefined)
    const filesLeft = useSelector<RootState, number | undefined>(state => state.uploadFiles.files?.length)


    function onFileSelected(e: React.ChangeEvent<HTMLInputElement>) {
        let files = [...e.target.files || []];
        dispatch(doFilesUpload(files, props.albumInfo))
    }

    function showLoginModal(){
        dispatch({type: SHOW_LOGIN_MODAL})
    }

    return (
        <>
            <div className="album-info">
                <div className="album-title">
                    <span>{props.albumInfo.name}</span>
                    <span className="horizontal-line"/>
                </div>
                <img className="album-cover" src={props.albumInfo.cover} alt=""/>
                {/*<div>*/}
                {/*    {props.users.map((user, i) =>*/}
                {/*        <CircularImage key={i} imageLink={user.profilepicture}/>*/}
                {/*    )}*/}
                {/*</div>*/}
                <div>
                    {/*<a className="share-button" style={{margin: "0 5px"}}*/}
                    {/*   href={`mailto:?subject=${shareSubject}&body=${shareBody}`}><span>Share</span></a>*/}
                    {(user && isUploadInProgress) && <label className="custom-file-upload" style={{margin: "0 5px"}} >
                        Uploading in progress ({filesLeft ? filesLeft + 1 : 1} files left)
                    </label>}
                    {(user && !isUploadInProgress) && <label className="custom-file-upload" style={{margin: "0 5px"}} >
                        <input type="file" accept="video/mp4,image/png,image/jpg" onChange={onFileSelected} multiple disabled={isUploadInProgress}/>
                        Upload more
                    </label>}
                    {!user && <span style={{textDecoration: "underline", cursor: "pointer"}} onClick={showLoginModal}>Sign up to upload files</span>}
                </div>
            </div>
            <Gallery images={props.images}/>
        </>
    )
}

export default AlbumViewer;